// src/components/BinInstruction/BinInstruction.jsx
import React from "react";

const BinInstruction = ({ binNumber, binType, onBack }) => {
    return (
        <div
            className="flex flex-col justify-center items-center h-screen w-screen"
            style={{ backgroundColor: "#234C2C", fontFamily: "'Instrument Serif', serif" }}
        >

            <h1 className="text-[#F6F8D0] text-center font-bold text-6xl md:text-7xl lg:text-8xl leading-tight">
                Put item in:
                <br />
                BIN {binNumber} - {binType.toUpperCase()}
            </h1>

            <button
                onClick={onBack}
                className="mt-16 px-8 py-4 text-xl rounded-full bg-[#F6F8D0] text-[#234C2C] font-semibold hover:opacity-90 transition"
            >
                Back
            </button>
        </div>
    );
};

export default BinInstruction;
